import { render } from "./H5Player.vue?vue&type=template&id=1f7fac16"
import script from "./H5Player.vue?vue&type=script&lang=js"
export * from "./H5Player.vue?vue&type=script&lang=js"

import "./H5Player.vue?vue&type=style&index=0&id=1f7fac16&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__